import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { canEditLinkedAccountOwnerAndSyncSelector } from '../../../../../../../CommonSelectors/CommonAreaSelector';
import { AccountFormContext } from '../context/AccountFormProvider';

interface AccountFormFieldDisabledOptions {
  skipAccountFormProvider?: boolean;
}

export const useCanEditLinkedAccountOwnerAndSync = ({
  skipAccountFormProvider = false,
}: AccountFormFieldDisabledOptions = {}) => {
  const accountFormContext = useContext(AccountFormContext);
  const canEditLinkedAccountOwnerAndSync = useSelector(canEditLinkedAccountOwnerAndSyncSelector);

  if (skipAccountFormProvider) {
    return { canEditOwnerAndSyncOnly: false };
  }

  if (!accountFormContext) {
    throw new Error('useCanEditLinkedAccountOwnerAndSync must be used within a AccountFormProvider');
  }

  const { accounts, localSaveOptions, accountId } = accountFormContext;

  const selectedAccount = localSaveOptions
    ? localSaveOptions.data?.bankAccount
    : accounts.find(({ AccountId }) => AccountId === accountId);

  const isLinkedAccount = !!selectedAccount?.IsLinked;

  return {
    canEditOwnerAndSyncOnly:
      !localSaveOptions && isLinkedAccount && canEditLinkedAccountOwnerAndSync,
  };
};

/** When the form is globally disabled, owner and sync fields remain editable in limited linked-account mode. */
export const useAccountFormFieldDisabled = (
  ownerAndSyncField = false,
  { skipAccountFormProvider = false }: AccountFormFieldDisabledOptions = {},
) => {
  const {
    formState: { disabled },
  } = useFormContext();
  const { canEditOwnerAndSyncOnly } = useCanEditLinkedAccountOwnerAndSync({
    skipAccountFormProvider,
  });

  if (ownerAndSyncField && canEditOwnerAndSyncOnly) {
    return false;
  }

  return disabled;
};
